import { ShieldCheck } from 'lucide-react';
import Table from '@/components/table/components/Table.tsx';
import EmptyTable from '@/components/table/components/EmptyTable.tsx';
import { FilterCriteriaDto } from '@/components/table/types/FilterCriteriaDto.tsx';
import insuredParticipantsApi from '@/features/dashboard/insurances/api/insuredParticipantsApi.ts';
import { insuredParticipantsApiQueryKeys } from '@/features/dashboard/insurances/api/insurancesApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';
import useGetBookingDetails from '@/features/dashboard/bookings/hooks/useGetBookingDetails.ts';
import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';

/**
 * Zakładka „Ubezpieczenia” ekranu rezerwacji. Backend nie ma listy ubezpieczonych
 * per rezerwacja, więc tabela idzie po zapisującym — w tym modelu jedna rezerwacja.
 */
const BookingInsurancesTab = () => {
  const { bookingId } = useDetailsScreen();
  // Metryczkę rezerwacji dociąga loader ekranu, więc zapisujący jest tu od pierwszego rysowania.
  const { data: booking } = useGetBookingDetails(bookingId);
  const clientId = booking?.client.id;

  if (!clientId) return null;

  return (
    <Table
      queryKey={insuredParticipantsApiQueryKeys.byClient(clientId)}
      fetchData={(pr, fc: FilterCriteriaDto) =>
        insuredParticipantsApi.getAllByClient(clientId, pr, fc)
      }
      fetchTableDef={() =>
        insuredParticipantsApi.getTableDefinitionByClient(clientId)
      }
      tagTargetType={TaggableType.INSURANCE}
      emptyDataComponent={
        <EmptyTable
          title="Brak ubezpieczonych"
          description="Tutaj pojawią się uczestnicy tej rezerwacji objęci ubezpieczeniem."
          icon={<ShieldCheck />}
        />
      }
    />
  );
};

export default BookingInsurancesTab;
